// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n[data-v-4bc1b403] span.owner,[data-v-4bc1b403] span.demo,[data-v-4bc1b403] span.user{ border-radius: 4px; padding: 3px 4px; background: var(--main-blue-3); color: #fff;\n}\n[data-v-4bc1b403] span.demo{ background: #fcef91; color: #615b2b;\n}\n[data-v-4bc1b403] span.user{ background: var(--main-gray-2); color: var(--main-gray-5);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
